export default __webpack_public_path__ + "static/media/new-logo.1f0ea667.svg";